import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, ViewEncapsulation, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { OwnersService } from 'app/services/owners.service';
import { AuthenticationService } from 'app/services';
import { BaseService } from 'app/_helpers/base/base.service';

@Component({
  selector: 'app-create-invoices',
  templateUrl: './create-invoices.component.html',
  styleUrls: ['./create-invoices.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None
})
export class CreateInvoicesComponent implements OnInit {
  form: UntypedFormGroup;
  data: any;
  showContract = false as boolean;
  showBookings = false as boolean;

  showProperty = true;
  agency: any;
  ownerData: any;
  accountData: any;
  rentalPriceTotal: any;
  constructor(
    public matDialogRef: MatDialogRef<CreateInvoicesComponent>,
    private formBuilder: UntypedFormBuilder,
    private _ownersService: OwnersService,
    private router: Router,
    private _authenticationService: AuthenticationService,
    private _gService: BaseService,
    @Inject(MAT_DIALOG_DATA) public _data: any
  ) {
    this.agency = this._authenticationService.currentAgencyValue;
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      invoice_type: [{ value: '', disabled: false }, [Validators.required]],
      what_to: [{ value: '', disabled: false }, [Validators.required]],
      who_to: [{ value: '', disabled: false }, [Validators.required]]
    });
    if (this._data && this._data.relatedTo === 'contract') {
      this.showContract = true;
    } else if (this._data && this._data.relatedTo === 'bookings') {
      this.showBookings = true;
      if (this._data.data && this._data.data.p_data && this._data.data.p_data.private_info_object && this._data.data.p_data.private_info_object[this.agency._id]
        && this._data.data.p_data.private_info_object[this.agency._id].owner_id) {
        this._ownersService.getById(this._data.data.p_data.private_info_object[this.agency._id].owner_id).subscribe((owner_data: any) => {
          this.ownerData = owner_data;
        });
      }
    }else if (this._data && this._data.relatedTo === 'properties') {
      this.showProperty = true;
      if (this._data.data && this._data.data.private_info_object && this._data.data.private_info_object[this.agency._id]
        && this._data.data.private_info_object[this.agency._id].owner_id) {
        this._ownersService.getById(this._data.data.private_info_object[this.agency._id].owner_id).subscribe((owner_data: any) => {
          this.ownerData = owner_data;
        });
      }
      if (this._data.data && this._data.data._id && this._data.data._id) {
        let filter = { 
          property_id: this._data.data._id,
          sort: ['contract_id', 'SORT_DESC']
        };
        this._gService.post('rental-contracts/search?pagination=false&expand=account_data', filter, 'Yii').subscribe(data => {
          if (data && data[0]) {
            if (data[0].account_data) {
              this.accountData = data[0].account_data;
            }
            if (data[0].rental_price_tottal) {
              this.rentalPriceTotal = data[0].rental_price_tottal;
            }
          }
        });
      }
    }
  }

  createInvoice(): void {
    if (this.form.invalid) {
      return;
    }
    let createData = this._data.data;
    let dataObj = {} as any;
    const postData = this.form.getRawValue();
    dataObj.invoice_type = postData.invoice_type;
    if (this._data.relatedTo && this._data.relatedTo === 'contract') {
      if (postData.who_to && postData.who_to == 'owner') {
        dataObj.invoice_to = createData.owner_data;
      } else if (postData.who_to && postData.who_to == 'renter') {
        dataObj.invoice_to = createData.account_data;
      }
      if (postData.what_to && postData.what_to == 'rental_commission') {
        dataObj.invoice_contract = createData.agency_commission;
      } else if (postData.what_to && postData.what_to == 'rental_amount') {
        let objInvoiceData = {} as any;
        objInvoiceData.value = createData.rental_price_tottal;
        objInvoiceData.total_vat = createData.vat;
        dataObj.invoice_contract = objInvoiceData;
      } else if (postData.what_to && postData.what_to == 'utilities') {
        if (createData.utilities && createData.utilities[0] && createData.utilities[0].amount) {
          let objInvoiceData = {} as any;
          objInvoiceData.value = createData.utilities[0].amount;
          objInvoiceData.total_vat = 0;
          dataObj.invoice_contract = objInvoiceData;
        }
      }
      dataObj.invoice_for = 'rental_contract';

    } else if (this._data.relatedTo && this._data.relatedTo === 'bookings') {
      let invoice_bookings = {} as any;
      if (postData.who_to && postData.who_to == 'owner') {
        dataObj.invoice_to = this.ownerData;
      } else if (postData.who_to && postData.who_to == 'renter') {
        dataObj.invoice_to = createData.account_data;
      }
      if (postData.what_to && postData.what_to == 'rental_commission') {
        invoice_bookings.value = createData.commission;
        dataObj.invoice_bookings = invoice_bookings;
      } else if (postData.what_to && postData.what_to == 'deposit') {
        let objInvoiceData = {} as any;
        objInvoiceData.value = createData.deposit_price;
        objInvoiceData.total_vat = createData.vat ? createData.vat : 0;
        dataObj.invoice_bookings = objInvoiceData;
      } else if (postData.what_to && postData.what_to == 'security_deposit') {
        let objInvoiceData = {} as any;
        objInvoiceData.value = createData.refundable_security_deposit ? createData.refundable_security_deposit : 0;
        objInvoiceData.total_vat = createData.vat ? createData.vat : 0;
        dataObj.invoice_bookings = objInvoiceData;
      } else if (postData.what_to && postData.what_to == 'final_amount') {
        let objInvoiceData = {} as any;
        objInvoiceData.value = createData.end_price ? createData.end_price : 0;
        objInvoiceData.total_vat = createData.vat ? createData.vat : 0;
        dataObj.invoice_bookings = objInvoiceData;
      } else if (postData.what_to && postData.what_to == 'manual_amount') {
        let objInvoiceData = {} as any;
        objInvoiceData.value = 0;
        objInvoiceData.total_vat = 0;
        dataObj.invoice_bookings = objInvoiceData;
      }
      dataObj.invoice_for = 'bookings';
    } else if (this._data.relatedTo && this._data.relatedTo === 'properties') {
      if (postData.who_to && postData.who_to == 'owner') {
        dataObj.invoice_to = this.ownerData;
      } else if (postData.who_to && postData.who_to == 'renter') {
        dataObj.invoice_to = createData.account_data;
        if (!dataObj.invoice_to && this.accountData) {
          dataObj.invoice_to = this.accountData;
        }
      }
      if (postData.what_to && postData.what_to == 'rental_commission') {
        let objInvoiceData = {} as any;
        if(createData && createData.sale && createData.private_info_object && createData.private_info_object[this.agency._id]
          && createData.private_info_object[this.agency._id].commission){
            objInvoiceData.value = createData.private_info_object[this.agency._id].commission;
        } else if(createData && createData.lt_rental && createData.ltr && createData.ltr.commission){
          objInvoiceData.value = createData.ltr.commission;
        } else if(createData && createData.st_rental && createData.rental_commission){
          objInvoiceData.value = createData.objInvoiceData;
        }
        dataObj.invoice_property = objInvoiceData;
        dataObj.rental_commission = true;
      }else if (postData.what_to && postData.what_to == 'management_commission') {
        let objInvoiceData = {} as any;
        if(createData && createData.lt_rental && createData.ltr && createData.ltr.management_commission){
          objInvoiceData.value = createData.ltr.management_commission;
        } 
        dataObj.invoice_property = objInvoiceData;
        dataObj.management_commission = true;
      }else if (postData.what_to && postData.what_to == 'rent') {
        let objInvoiceData = {} as any;
        if(this.rentalPriceTotal){
          objInvoiceData.value = this.rentalPriceTotal;
        } 
        dataObj.invoice_property = objInvoiceData;
        dataObj.rent = true;
      }
      dataObj.invoice_for = 'properties';
    }
    if (dataObj) {
      this.router.navigate(['/templates/invoices/outgoing/create'], { state: { data: dataObj } });
      this.matDialogRef.close();
    }

  }

}
